module.exports = __webpack_public_path__ + "cancel.svg?6eaa9a742d852968c0037cf5c6117759";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cancel.svg
// module id = 6
// module chunks = 0